package model

object Profiles {
    const val FLOWR = "FLOWR"
    const val ODOO = "ODOO"
    const val DEFAULT = "DEFAULT"
}

const val notRdy = " (not rdy)"
const val noPod = "No pod running"
const val noPodPaused = "Paused"

const val projectName = "taktik-dev"
const val clusterName = "kube-1"

const val buildmanagerBackendUrl = "https://console.cloud.google.com/logs/query;query=resource.type%3D%22k8s_container%22%0Aresource.labels.namespace_name%3D%22buildmanager%22%0Aresource.labels.container_name%3D%22buildmanager-backend%22?project=$projectName"
